const getters = {
  state: {
    token: '',
  },
  getters: {
    token: state => state.token
  },
  mutations: {
    // 存储token
    setToken: (state, value) => {
      state.token = value
    }
  },
  actions: {}
}
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js